import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import { useActions } from "../../hooks/useActions";
import { closeAppModal } from "../../redux/page/page.actions";
import Datalayer from "../../libs/vendors/data-layer";
import { CLICK_ACTIONS, MODAL_NAMES, MODAL_TYPES } from "../../constants/datalayer";
import Modal from "../Modal/Modal";

const GenericErrorModal = React.lazy(() =>
    import("../GenericErrorModal/GenericErrorModal")
);

const NoInternetModal = React.lazy(() => import("../NoInternetModal/NoInternetModal"));

const ServiceErrorModal = React.lazy(() =>
    import("../ServiceErrorModal/ServiceErrorModal")
);

const TimeOutErrorModal = React.lazy(() =>
    import("../TimeOutErrorModal/TimeOutErrorModal")
);

function AppModal() {
    const { appModal } = useSelector(state => ({
        appModal: state.Page.appModal,
    }));
    const actions = useActions(
        {
            closeAppModal,
        },
        []
    );
    const [modalType, setModalType] = useState(null);

    const onCloseModal = () => {
        Datalayer.sendModal(MODAL_TYPES.ERROR, modalType, CLICK_ACTIONS.CLOSE_MODAL);
        actions.closeAppModal();
    };

    const modalContent = useMemo(() => {
        if (appModal.type === "generic-error") {
            setModalType(MODAL_NAMES.GENERIC_MODAL);
            Datalayer.sendModal(MODAL_TYPES.ERROR, MODAL_NAMES.GENERIC_MODAL);
            return <GenericErrorModal />;
        }

        if (appModal.type === "no-internet") {
            setModalType(MODAL_NAMES.NO_INTERNET);
            Datalayer.sendModal(MODAL_TYPES.ERROR, MODAL_NAMES.NO_INTERNET);
            return (
                <NoInternetModal
                    showActionButton={appModal.showActionButton}
                    actionType={appModal.actionType}
                />
            );
        }

        if (appModal.type === "service-error") {
            setModalType(MODAL_NAMES.SERVICE_ERROR);
            Datalayer.sendModal(MODAL_TYPES.ERROR, MODAL_NAMES.SERVICE_ERROR);
            return <ServiceErrorModal />;
        }

        if (appModal.type === "timeout-error") {
            setModalType(MODAL_NAMES.TIMEOUT_ERROR);
            Datalayer.sendModal(MODAL_TYPES.ERROR, MODAL_NAMES.TIMEOUT_ERROR);
            return (
                <TimeOutErrorModal
                    showActionButton={appModal.showActionButton}
                    actionType={appModal.actionType}
                />
            );
        }

        return null;
    }, [appModal]);

    return (
        <Modal open={appModal.isOpen} onClose={onCloseModal}>
            <React.Suspense fallback={null}>{modalContent}</React.Suspense>
        </Modal>
    );
}

export default React.memo(AppModal);
